<template>
	<b-modal
		:hide-footer="true"
		:no-close-on-backdrop="true"
		:title="titulo"
		centered
		size="lg"
		@hidden="cancelar"
		id="modal-remanejar-responsavel"
	>
		<load v-if="loading" mode="table" message="Trocando o responsável familiar" />
		<div v-else class="row">
			<div v-if="!organizarPosicoes" class="col-md-12">
				<table class="b-table table table-striped b-table-stacked-md">
					<thead>
						<tr>
							<th></th>
							<th>Nome Completo</th>
							<th>Posição Familiar</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="familiar in familiares" :key="familiar.id">
							<td>
								<input
									type="radio"
									:id="familiar.id"
									:value="familiar"
									v-model="novo_responsavel"
								/>
							</td>
							<td>
								<strong>{{ familiar.nome_completo }}</strong>
								<br />
								<span v-if="familiar.documento">
									<span v-if="familiar.documento.nis">NIS: {{ familiar.documento.nis }}</span>
									<span v-else>
										<b-link
											href="#"
											v-b-tooltip.hover
											title="Não sabe o número do NIS ou não foi inserido no cadastro!"
										>
											NIS:
											<b-icon
												icon="exclamation-triangle-fill"
												variant="warning"
												animation="fade"
											></b-icon>
										</b-link>
									</span>
								</span>
								<br />
								Sexo:
								<span v-if="familiar.sexo == 1"> MASCULINO </span>
								<span v-if="familiar.sexo == 2"> FEMININO </span>
								<span v-else> INTERSEXO </span>
								<br />
								Idade: {{ familiar.idade }} ano(s)
							</td>
							<td>
								<span v-for="posicao in $root.arrays.posicao_familiar" :key="posicao.id">
									<span v-if="posicao.id == familiar.posicao_familiar">
										{{ posicao.value }}
									</span>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div v-else class="col-md-12">
				<div class="card" v-if="novo_responsavel">
					<h5>Novo responsável</h5>
					<table class="b-table table table-striped b-table-stacked-md">
						<thead>
							<tr>
								<th>NIS</th>
								<th>Nome Completo</th>
								<th>Idade</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{ novo_responsavel.documento ? novo_responsavel.documento.nis : "" }}</td>
								<td>{{ novo_responsavel.nome_completo }}</td>
								<td>{{ novo_responsavel.idade }} ano(s)</td>
							</tr>
						</tbody>
					</table>
				</div>
				<h5>Selecione abaixo o tipo de parentesco</h5>
				<OrganizarPosicao :familiares="familiaresOrganizar" />
			</div>
		</div>
		<div class="row">
			<div class="col-12 d-flex justify-content-end">
				<button
					v-if="!organizarPosicoes"
					class="btn btn-primary"
					@click="
						organizarPosicoes = true;
						titulo =
							'Informe o parentesco dos integrantes da família em relação ao novo Responsável';
						organizarMembros();
					"
				>
					<i class="mdi mdi-account-check"></i> Selecionar Responsável
				</button>
				<button v-else class="btn btn-success" @click="submit">
					<i class="mdi mdi-check-circle"></i> Concluir troca
				</button>
				<button class="btn btn-danger" @click="cancelar">
					<i class="mdi mdi-close"></i> Cancelar
				</button>
			</div>
		</div>
	</b-modal>
</template>
<script>
import OrganizarPosicao from "./Remanejar/OrganizarPosicao";
export default {
	components: { OrganizarPosicao },
	props: ["familia", "pessoa"],
	data() {
		return {
			titulo: "Escolha o novo responsável familiar",
			novo_responsavel: "",
			loading: false,
			organizarPosicoes: false,
			familiaresOrganizar: [],
		};
	},
	computed: {
		familiares() {
			return this.familia.familiares.filter(
				(elem) =>
					parseInt(elem.idade) > 16 &&
					(parseInt(elem.estado_cadastral_cadunico) == 3 ||
						parseInt(elem.estado_cadastral_cadunico) == 1 || parseInt(elem.estado_cadastral_cadunico) == 0 || elem.estado_cadastral_cadunico == null)
			);
		},
	},
	methods: {
		submit() {
			this.loading = true;
			axios
				.post("api/dashboard/familias/trocarresponsavel", {
					responsavel: this.novo_responsavel,
					familiares: this.familiaresOrganizar,
				})
				.then((response) => {
					this.loading = false;
					this.cancelar();
					this.$snack.success({
						button: false,
						text: "Troca realizada com sucessos.",
					});
					this.$emit("atualizar");

					if (
						this.$refs.headerFamilia &&
						this.$refs.headerFamilia.refreshHistoricoEstadoCadastral
					) {
						this.$refs.headerFamilia.refreshHistoricoEstadoCadastral();
					}
				});
		},
		organizarMembros() {
			this.familiaresOrganizar = this.familia.familiares.filter(
				(elem) =>
					this.novo_responsavel.id != elem.id &&
					(parseInt(elem.estado_cadastral_cadunico) == 3 ||
						parseInt(elem.estado_cadastral_cadunico) == 1)
			);
			this.familiaresOrganizar.forEach((e) => {
				if (e.posicao_familiar == 1) {
					e.posicao_familiar = 10;
				}
			});
		},
		cancelar() {
			Object.assign(this.$data, this.$options.data.call(this));
			this.$bvModal.hide("modal-remanejar-responsavel");
		},
	},
};
</script>
